function initProductCardSlider() {
  $('.product-card-slider').slick({
    dots: true,
    arrows: true,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
}
document.addEventListener('DOMContentLoaded', initProductCardSlider);


function switchImage(productId, imageSrc, variantUrl, variantTitle, variantId) {
  if (imageSrc.indexOf('error') == -1) {
    $(`#product_media-${productId} .slick-slide.slick-current img`).attr('src', imageSrc);
    // console.log(`${productId} switch product's img: ${imageSrc}`);
  }
  $(`#product_media-${productId} a.slick-slide.slick-current`).attr('href', variantUrl);
  $(`#stone_title-${productId}`).text(variantTitle);
  $(`#stone_variant-${variantId}`).addClass('active').siblings().removeClass('active');
}

function toggleDescription() {
  $(`.product__description`).toggleClass('expand');
  if ($(`.product__description`).hasClass('expand')) {
    $(`#toggle-description`).text('Show less...');
  } else {
    $(`#toggle-description`).text('Read more >');
  }
}

function showMoreImages() {
  $('.product__media-list').addClass('show-all');
  $('.product__media-show-more').hide();
}

function toggleStoneProfile(stoneId) {
  var stoneProfileId = `profile-${stoneId}`;
  var listId = `list-${stoneId}`;
  var stoneProfile = $(`#${stoneProfileId}`);
  stoneProfile.toggle(500, function() {
    if (stoneProfile.is(':visible')) {
      $(`#${stoneId}`).removeClass('collapsed');
      $(`#${listId}`).addClass('active');
      location.href = `#${stoneId}`;
    }
    else {
      $(`#${stoneId}`).addClass('collapsed');
      $(`#${listId}`).removeClass('active');
    }
  });
}
